import React from "react"; 
import { Link } from "react-router-dom";    
import UserTypesListContent from "../../../components/Dashboard/UserTypesListContent";

const UserTypesList = () => {
  return (
    <>
      {/* Breadcrumb */}
      {/* <div className="breadcrumb-card">
        <h5>List of User Types</h5>

        <ul className="breadcrumb">
          <li>
            <Link to="/dashboard/ecommerce/">
              <i className="material-symbols-outlined">home</i>
              Dashboard
            </Link>
          </li>
          <li>User Types List</li>
        </ul>
      </div> */}

      <UserTypesListContent />
    </>
  );
};

export default UserTypesList;
